const ZERO_PRICE_DISPLAY = "R$ 0,00";

export function parseMaskedCurrencyToNumber(price: string): number {
  return Number(price.replace(/[^\d,]/g, "").replace(",", "."));
}

export function isValidProductPriceInput(price?: string | null): boolean {
  if (!price || !String(price).trim()) {
    return false;
  }
  if (String(price).trim() === ZERO_PRICE_DISPLAY) {
    return false;
  }
  const numeric = parseMaskedCurrencyToNumber(price);
  return !Number.isNaN(numeric) && numeric > 0;
}
